import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import BlogDetails from './BlogDetails';
import SinglePostSidebar from './SinglePostSidebar';
import Header from '../../components/Layout/Header/Header';
import Footer from '../../components/Layout/Footer/Footer';
import Newsletter from '../../components/Common/Newsletter';
import ScrollToTop from '../../components/Common/ScrollTop';
import OffWrap from '../../components/Layout/Header/OffWrap';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import SearchModal from '../../components/Layout/Header/SearchModal';

// Image
import favIcon from '../../assets/img/fav-orange.png';
import Logo from '../../assets/img/logo/cat_logo.png';
import footerLogo from '../../assets/img/logo/cat_logo.png';

import postImage from '../../assets/img/blog/inner/1.jpg';
import post1Image from '../../assets/img/blog/inner/b7.jpeg'

// Breadcrumbs Background Image
import bannerbg from '../../assets/img/breadcrumbs/5.jpg';

const SinglePostRightSidebar = (props) => {

    return (
        <React.Fragment>
            <Helmet>
                <link rel="icon" href={favIcon} />
            </Helmet>
            <OffWrap />
            <Header
                parentMenu='blog'
                secondParentMenu='blogSingle'
                headerNormalLogo={Logo}
                headerStickyLogo={Logo}
                mobileNormalLogo={Logo}
                CanvasLogo={Logo}
                CanvasClass="right_menu_togle hidden-md"
                headerClass="full-width-header header-style1 home8-style4"
                TopBar='enable'
                TopBarClass="topbar-area home8-topbar"
                emailAddress='perfectschool777@gmail.com'
            />

            <SiteBreadcrumb
                pageTitle="Мама-училка? Так, easy!"
                pageName="Мама-училка? Так, easy!"
                breadcrumbsImg={bannerbg}
            />

            {/* Blog Details Start */}
            <div className="rs-inner-blog orange-style pt-100 pb-100 md-pt-80 md-pb-80">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-12 order-last">
                            <div className="widget-area">
                                <SinglePostSidebar />
                            </div>
                        </div>
                        <div className="col-lg-8 pr-50 md-pr-14">
                          <div className="blog-deatails">
                            <div className="bs-img">
                                <img
                                    src={post1Image}
                                    alt="Post Image"
                                />
                            </div>
                            <div className="blog-full">
                                <div className="blog-desc">
                                    <p>
                                      Починаючи з чудової новини про вагітність, усі працюючі дівчата починають замислюватися про те, як же залишитися в соціумі і не "випасти з життя" на три роки. Наслухавшись від інших "матусь" жахів про те, що при появі дитини молоду матір закрито в чотирьох стінах мінімум на рік, максимум на 9, мимоволі починається паніка. І мене ця паніка не минула. Бажання розвиватись мене підштовхнуло на те, щоб відразу після народження малюка продовжити викладати. Було страшно і незвично, і головне питання – як же? Як виявилось, не все так страшно. Студенти люблять маленьких дітей і завжди все розуміють. Проводити заняття з маленьким не просто, але можливо. Головне погодувати і бути поряд. З дітьми він засинає, із дорослими намагається розмовляти. Поки спить, окрім домашніх турбот, можна й самій повчитися. Замість безглуздого серфа в інтернеті, ведення блогу "матуся в декреті" про какашки та памперси, - включати серіали улюбленою іноземною мовою, або радіо, але Deutsche Welle. Дуже важлива у цій справі підтримка та розуміння. Дякую Анжеліці, керівникові, яка завжди вірить у мене і мотивує, вона мій приклад і натхненник, щоразу, коли хочеться все кинути, вона каже, що пишається мною і сама думка про те, щоб здатися зникає, і чоловікові, який дивиться на це все, дивується, але підтримує у всьому, що б я не вигадала. Завдяки заняттям та цілодобовій зайнятості немає часу на дурні думки та депресію. Навпаки, десь беруться сили працювати, брати нових студентів, дбати про сім'ю і бути при цьому щасливою. Послання всім дівчаткам, які плачуться, що важко з дитиною: це все у вашій голові, якби не уроки, я навіть не знала б, куди подіти купу часу, що звільнився! Головне у цьому всім бажання. А там і нагода з'являється.
                                    </p>
                                </div>
                                <div className="blog-desc">
                                    <p>
                                      PS: При написанні статті жодна дитина не постраждала.
                                    </p>
                                </div>
                            </div>
                        </div>
                            {/* <BlogDetails /> */}
                        </div>
                    </div>
                </div>
            </div>
            {/* Blog Details End */}

            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />

            {/* scrolltop-start */}
            <ScrollToTop
                scrollClassName="scrollup orange-color"
            />
            {/* scrolltop-end */}

            <SearchModal />
        </React.Fragment>
    );
}


export default SinglePostRightSidebar;



